// ** React Imports
import { useState, useEffect } from 'react'
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Chip,
  Button,
  IconButton,
  Tooltip,
  Divider,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  FormHelperText
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import Icon from '../../../components/icon'
import { useToast } from '../../../components/ToastProvider'
import { useForm, Controller } from 'react-hook-form'
import apiUrl from '../../../configs/constant';
import axios from 'axios'
import Swal from 'sweetalert2'

export default function InboundList() {
  const { showToast } = useToast()
  const navigate = useNavigate()

  const [listData, setListData] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [search, setSearch] = useState('');

  const userData = JSON.parse(localStorage.getItem('user')!)
  const token = userData.token
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm()


  const filteredData = listData.filter(row => {
    const keyword = search.toLowerCase();

    return (
      row.name?.toLowerCase().includes(keyword) ||
      row.phone?.toLowerCase().includes(keyword) ||
      row.messages?.some((m: string) =>
        m.toLowerCase().includes(keyword)
      )
    );
  });

  const getListData = () => {
    setLoading(true)
    const url = apiUrl.apiUrl + '/omni/inbound/list-new-whatsapp-chats'
    axios
      .get(url, {
        params: {},
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        setLoading(false)
        if (response.data.success) {
          const data = response.data.data
          setListData(data)
        } else {
          showToast(response.data.message, "error");
        }
      })
  }

  useEffect(() => {
    getListData()
  }, [])

  // =====================
  // Action Handlers
  // =====================
  const handleGetTouch = (rows: any) => {
    Swal.fire({
      title: 'Konfirmasi',
      text: 'Apakah anda ingin menyimpan contact ini?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#337ab7',
      cancelButtonColor: '#ffc107',
      confirmButtonText: 'Simpan'
    }).then(result => {
      if (!result.isConfirmed) return;

      Swal.fire({
        title: 'Now loading ...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const payload = {
        hrstaff_id: userData?.data?.hrstaff_id,
        nama: rows?.name,
        phone: rows?.phone
      };

      const url = `${apiUrl.apiUrl}/omni/inbound/get-touch/${rows.id}`;

      axios
        .post(url, payload, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(res => {
          Swal.close();

          if (res.data.success) {
            showToast('Chat berhasil diambil 🎯', 'success');
            getListData();
          } else {
            showToast(res.data.message, 'error');
          }
        })
        .catch(err => {
          Swal.close();

          showToast(
            err?.response?.data?.message || 'Gagal mengambil chat',
            'error'
          );
        });
    });
  };


  const handleDelete = (id: number) => {
    const url = `${apiUrl.apiUrl}/omni/inbound/delete/${id}`

    axios
      .post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(response => {
        if (response.data.success) {
          const data = response.data.data
          setListData(data)
        } else {
          showToast(response.data.message, "error");
        }
      })
    getListData();
  }

  const handleAddInbound = (data: any) => {
    const newInbound = {
      name: data.name,
      phone: data.phone,
      message: data.message,
    }

    axios.post(apiUrl.apiUrl + '/omni/inbound/add', newInbound, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(response => {
      if (response.data.success) {
        showToast('Inbound chat berhasil ditambahkan', 'success');
        getListData();
      } else {
        showToast(response.data.message, 'error');
      }
    })

    setOpenDialog(false)
    reset()
  }


  return (
    <Grid container spacing={3}>
      {/* Header */}
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="h5" fontWeight="bold">
              📥 Incoming Leads
            </Typography>
            <Typography variant="body1">
              Total Incoming Leads: {listData.length}
            </Typography>
          </Box>

          <Fab color="primary" onClick={() => setOpenDialog(true)}>
            <Icon icon="mdi:plus" />
          </Fab>
        </Box>
        <Divider sx={{ mt: 2 }} />
      </Grid>

      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap'
          }}
        >
          <TextField
            size="small"
            placeholder="Cari nama, nomor, atau chat..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <Icon icon="mdi:magnify" style={{ marginRight: 8 }} />
              ),
              endAdornment: search && (
                <Icon
                  icon="mdi:close-circle"
                  onClick={() => setSearch('')}
                  style={{ cursor: 'pointer', marginRight: 2 }} />
              )
            }}
            sx={{ width: { xs: '100%', sm: 320 } }}
          />
        </Box>
      </Grid>

      {/* Cards */}
      {loading && (
        <Grid item xs={12}>
          <Box sx={{ textAlign: 'center', mt: 10 }}>
            <Box
              sx={{
                display: 'inline-block',
                width: 60,
                height: 60,
                border: '4px solid #e0e0e0',
                borderTop: '4px solid #1976d2',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                '@keyframes spin': {
                  '0%': { transform: 'rotate(0deg)' },
                  '100%': { transform: 'rotate(360deg)' }
                }
              }}
            />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Memuat inbound chat...
            </Typography>
          </Box>
        </Grid>
      )}

      {filteredData.map(row => (
        <Grid item xs={12} md={6} lg={4} key={row.id} sx={{ display: 'flex' }}>
          <Card
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 3,
              boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
              transition: '0.25s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 10px 28px rgba(0,0,0,0.12)'
              }
            }}
          >
            <CardContent
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {/* Header */}
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Avatar sx={{ bgcolor: '#25D366', mr: 2 }}>
                  <Icon icon="mdi:whatsapp" color="white" />
                </Avatar>

                <Box sx={{ flex: 1 }}>
                  <Typography fontWeight="bold">
                    {row.name || row.phone}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {row.phone} • {row.created_at}
                  </Typography>
                </Box>

                <Tooltip title="Hapus">
                  <IconButton onClick={() => handleDelete(row.id)}>
                    <Icon icon="mdi:trash" color="#E53935" />
                  </IconButton>
                </Tooltip>
              </Box>

              {/* Messages (SCROLLABLE) */}
              <Box
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  mb: 2,
                  pr: 1
                }}
              >
                {row.messages.map((message: string, index: number) => (
                  <Typography
                    key={index}
                    variant="body2"
                    sx={{ mb: 1, lineHeight: 1.5 }}
                  >
                    {message}
                  </Typography>
                ))}
              </Box>

              {/* Action */}
              <Button
                variant="contained"
                onClick={() => {
                  handleGetTouch(row)
                }}
                startIcon={<Icon icon="mdi:handshake" />}
                fullWidth
              >
                Get Touch
              </Button>
            </CardContent>
          </Card>
        </Grid>
      ))}

      {!loading && filteredData.length === 0 && (
        <Grid item xs={12}>
          <Box sx={{ textAlign: 'center', mt: 10, opacity: 0.6 }}>
            <Icon icon="mdi:inbox-remove" fontSize={60} />
            <Typography variant="h6">
              Data tidak ditemukan
            </Typography>
          </Box>
        </Grid>
      )}

      {!loading && listData.length === 0 && (
        <Grid item xs={12}>
          <Box sx={{ textAlign: 'center', mt: 10, opacity: 0.6 }}>
            <Icon icon="mdi:inbox-remove" fontSize={60} />
            <Typography variant="h6">
              Tidak ada inbound chat
            </Typography>
          </Box>
        </Grid>
      )}

      <Dialog
        maxWidth="sm"
        fullWidth
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      >
        <form onSubmit={handleSubmit(handleAddInbound)}>
          <DialogTitle>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              Tambah Inbound Manual
            </Typography>
          </DialogTitle>

          <DialogContent dividers sx={{ p: 3 }}>
            <Grid container spacing={3}>

              {/* Nama */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name="name"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Nama Customer"
                        placeholder="John Doe"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                  {errors.name && (
                    <FormHelperText sx={{ color: 'error.main' }}>
                      Nama wajib diisi
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {/* Phone */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name="phone"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Nomor WhatsApp"
                        placeholder="628xxxxxxxxx"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                  {errors.phone && (
                    <FormHelperText sx={{ color: 'error.main' }}>
                      Nomor WhatsApp wajib diisi
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {/* Pesan */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Controller
                    name="message"
                    control={control}
                    rules={{ required: false }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Pesan Awal"
                        multiline
                        rows={3}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                  {errors.message && (
                    <FormHelperText sx={{ color: 'error.main' }}>
                      Pesan wajib diisi
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

            </Grid>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button type="submit" variant="contained">
              Simpan
            </Button>
            <Button onClick={() => setOpenDialog(false)}>
              Batal
            </Button>
          </DialogActions>
        </form>
      </Dialog>

    </Grid>
  )
}
